import { getAppConfig } from "@/services/user/user";
import { makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";

export interface IConfig {
  web: Record<string, any>;
  matrix_web: Record<string, any>;
  admin: Record<string, any>;
}

export interface IAppStore {
  isInFrame: boolean;
  config: IConfig;
  isOdm: boolean;
  // createUserName: string;
}

class AppStore {
  // isInFrame = window.self !== window.top;
  config = JSON.parse(localStorage.getItem("AppStore") ?? "{}");
  // isOdm = +process.env.REACT_APP_AID !== 0;
  isOdm = false;

  constructor() {
    console.log(
      "process.env.REACT_APP_AID",
      +process.env.REACT_APP_AID !== 0,
      window.self !== window.top
    );

    // this.isOdm = +process.env.REACT_APP_AID !== 0;
    this.isOdm = false;
    // this.isInFrame = window.self !== window.top;
    makeAutoObservable(this);
    makePersistable(this, {
      name: "AppStore",
      properties: ["config", "isInFrame"],
      storage: window.localStorage,
    });
  }

  get isInFrame() {
    return window.self !== window.top;
  }

  async getConfig() {
    const data = await getAppConfig();
    console.log(data);
    this.config = data;
  }
}

const appStore = new AppStore();

export default appStore;
